<template>
  <b-card
    no-body
    img-top
    style="max-width: 20rem;"
    :img-src="item.images[0].location">
    <b-card-body class="border-top">
      <b-card-title>
        <b-link :to="'/products/' + item.slug">{{ item.name }}</b-link>
      </b-card-title>
      <b-card-sub-title :sub-title-text-variant="subtitleVariant">{{ item.price | toCurrency }}</b-card-sub-title>
      <b-card-text>{{ item.shortDescription | truncate(105) }}</b-card-text>
    </b-card-body>
    <b-list-group center flush v-if="rating">
      <b-list-group-item class="py-2 border-top ">
        <b-form-rating no-border size="sm" precision="1" :readonly="readonlyRating" variant="warning" show-value show-value-max :value="calculateRating(item)"></b-form-rating>
      </b-list-group-item>
      <b-list-group-item class="text-center" v-if="share">
        <b-button-group size="sm">
          <b-button @click="onShareToFacebook(item)" variant="outline-primary">
            <font-awesome-icon :style="{ color: 'info' }" :icon="['fab', 'facebook-square']"/>
          </b-button>
          <b-button @click="onShareToTwitter(item)" variant="outline-success">
            <font-awesome-icon :icon="['fab', 'twitter']"/>
          </b-button>
          <b-button @click="onShareToWhatsapp(item)" variant="outline-success">
            <font-awesome-icon :icon="['fab', 'whatsapp']"/>
          </b-button>
          <b-button @click="onShareToEmail(item)" variant="outline-info">
            <font-awesome-icon :icon="['fas', 'envelope']"/>
          </b-button>
        </b-button-group>
      </b-list-group-item>
      <b-list-group-item href="#" @click="onAddToCart(item)" class="text-center" v-if="cart">
        <font-awesome-icon :icon="['fas', 'shopping-cart']"/> Agregar al carrito
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>

<script>
export default {
  name: 'Product',
  props: {
    item: {},
    readonlyRating: { type: Boolean, default: () => true },
    subtitleVariant: { type: String, default: () => 'muted' },
    rating: { type: Boolean, default: () => true },
    share: { type: Boolean, default: () => true },
    cart: { type: Boolean, default: () => true }
  },
  data () {
    return {}
  },
  methods: {
    calculateRating (item) {
      if (!item.votes || (item.votes && item.votes.length === 0)) return 0

      const sum = item.votes.reduce((acc, row) => {
        return acc + row.vote
      }, 0)
      return sum / item.votes.length
    },
    onAddToCart (item) {
      item.quantity = 1
      this.$store.commit('addToCart', item)
      this.$bvToast.toast(`Se agregó ${item.name} a tu carrito.`, {
        title: 'Artículo agregado',
        solid: true,
        variant: 'info'
      })
    },
    onShareToFacebook (item) {
      console.log('facebook :::>', item)
    },
    onShareToTwitter (item) {
      console.log('twitter :::>', item)
    },
    onShareToWhatsapp (item) {
      console.log('whats :::>', item)
    },
    onShareToEmail (item) {
      console.log('email :::>', item)
    }
  }
}
</script>
